jQuery(document).foundation();

jQuery(document).ready(function($) {

	// Adds Flex Video to YouTube and Vimeo Embeds
  $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
    $(this).parent().addClass('responsive-embed widescreen')
  })

  // add arrow after button-link
  $('.button-link').each(function() {
    $('<span class="fa fa-arrow-right"></span>').insertAfter($(this));
  });

  // mobile nav
  $('#header-mobile-nav').height($(window).height() - ($('.header-top').outerHeight() + $('.header-main').outerHeight()));
  $("#header-mobile-toggle").on('click', function() {
    $('#header-mobile-nav').toggle();
  });

  // debugger
  $(window).on('resize', function() {
    $('.debugger .column-width').html($('.debugger .cell').eq(0).width())
    $('.debugger .gutter-width').html(parseInt($('.debugger .cell').eq(0).css('margin-left')) * 2)
    $('.debugger .container-padding').html(parseInt($('.debugger .grid-container').eq(0).css('padding-left')) * 2)
  }).trigger('resize')

  $('.debugger').on('click', function(e) {
    $(this).remove()
  })

})
